type MaterialColorIconProps = {
  colorHex: string;
};

export const MaterialColorIcon = ({ colorHex }: MaterialColorIconProps) => (
  <div className="flex w-full justify-center py-7">
    <div className="w-[40px] h-[40px] rounded-full aspect-square" style={{ backgroundColor: colorHex }}>
      <div
        className="rounded-full w-full h-full"
        style={{ background: 'linear-gradient(#fff -100%, #0000 50%, #000 350%)' }}
      />
    </div>
  </div>
);
